import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function KardexExpoInfo({ master }) {

    const [movimientos] = useState([
        {
            fecha: "2025-06-12 15:34:07",
            vuelo: "-",
            house: "-",
            piezas: 3,
            peso: 81,
            modulo: "DESISTIMIENTOS",
            movimiento: "Solicitud cancelada",
            usuario: "Ezequiel Bernal"
        },
        {
            fecha: "2025-06-12 14:42:30",
            vuelo: "-",
            house: "-",
            piezas: 3,
            peso: 81,
            modulo: "DESISTIMIENTOS",
            movimiento: "Aviso generado",
            usuario: "Ezequiel Bernal"
        },
        {
            fecha: "2025-04-03 00:34:07",
            vuelo: "-",
            house: "-",
            piezas: 3,
            peso: 81,
            modulo: "PRECAPTURA/CAPTURA",
            movimiento: "Captura de master",
            usuario: "Ezequiel Bernal"
        },
    ]);

    const handleDownloadCSV = () => {
        // Datos de la hoja
        const hojaCompleta = [
            ["Master", "Origen", "Descripción", "Piezas totales", "Peso total", "Días en almacén"],
            [master.number, master.origen, "", master.pzas, master.weight, ""],
            [],
            [],
            [],
            ...movimientos.map(item => [
                item.fecha,
                item.vuelo,
                item.house,
                item.piezas,
                item.peso,
                item.modulo,
                item.movimiento,
                item.usuario
            ])
        ];

        // Crear hoja y libro
        const ws = XLSX.utils.aoa_to_sheet(hojaCompleta);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Kardex");

        // Crear nombre dinámico con fecha y hora actual
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const fechaStr = `${now.getFullYear()}_${pad(now.getMonth() + 1)}_${pad(now.getDate())}_${pad(now.getHours())}_${pad(now.getMinutes())}_${pad(now.getSeconds())}`;
        const nameFile = `Reporte Kardex Expo__${fechaStr}.xlsx`;

        // Exportar archivo
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, nameFile);
    }

    return(
        <>
            <div className="container-fluid mt-5">
                <div className="row">
                    <div className="col-3">
                        <p><span className="fw-bold">Master:</span> {master.number}</p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Origen:</span> {master.origen} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Destino:</span> {master.destino} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">SHC:</span>  </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <p><span className="fw-bold">Piezas totales:</span> {master.pzas} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Peso total:</span> {master.weight} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Peso cobrable total:</span>  </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Descripción:</span>  </p>
                    </div>
                </div>
                <div className="row my-3">
                    <div className="col-6 d-flex">
                        <button className='btnn' onClick={handleDownloadCSV} >Descargar CSV</button>
                    </div>
                </div>

                <table className="table mt-5">
                    <thead className="text-center">
                        <tr>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Fecha</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Vuelo</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>House</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Piezas</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Peso</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Módulo</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Movimiento</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Usuario</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {movimientos.map((item, i) => (
                            <tr key={i}>
                                <td>{item.fecha}</td>
                                <td>{item.vuelo}</td>
                                <td>{item.house}</td>
                                <td>{item.piezas}</td>
                                <td>{item.peso}</td>
                                <td>{item.modulo}</td>
                                <td>{item.movimiento}</td>
                                <td>{item.usuario}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default KardexExpoInfo;